import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import {navigator, router} from 'lit-element-router';

import {when} from 'lit/directives/when.js';

import store from '../../store';

import style from '../../../../scss/profiles.scss';
import formPageStyle from '../../../../scss/formPage.scss';
import getRoutes from '../../routes';
import plus from '../../icons/plus';


@customElement('arc-account-profiles')
export class AccountProfiles extends connect(store)(router(navigator(LitElement))) {
	static styles = [formPageStyle, style];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.status = state.status;
		this.accountData = state.account.data.account;
		this.accountStatus = state.account.status;
		this.loggedIn = state.account.data.loggedIn;
	}

	static get routes() {
		return getRoutes();
	}

	router(route, params, query, data) {
		this.params = params;
		this.query = query;
	}

	async connectedCallback() {
		super.connectedCallback();
	}

	disconnectedCallback() {
		super.disconnectedCallback();
	}

	render() {
		const state = store.getState();
		return html`
			<div class="profiles">
				<arc-toolbar class="toolbar">
					<div slot="left">
						<arc-breadcrumbs>
							<span>${msg('Profiles')}</span>
						</arc-breadcrumbs>
					</div>
					<div slot="right">
					</div>
				</arc-toolbar>

				${when(
					this.loggedIn,
					() => html`
						<arc-profiles-list class="profileList"></arc-profiles-list>
					`
				)}

		`;
	}
}
